// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"Checkbox_checkbox__UjSYm","checkbox__check-box":"Checkbox_checkbox__check-box__1BXPe"};